{
  "language": {
    "name": "Français",
    "title": "Langue"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 4)}}"
  },
  "button": {
    "auto": "Auto",
    "bridge": "Bridge",
    "buy": "Acheter",
    "buyNow": "Acheter maintenant",
    "cancel": "Annuler",
    "connectWallet": "Connecter un portefeuille",
    "contactSupport": "Contacter le support",
    "continue": "Continuer",
    "copyAddress": "Copier l’adresse",
    "dark": "Sombre",
    "delete": "Supprimer",
    "disconnect": "Déconnecter",
    "done": "Terminé",
    "exchange": "Échanger",
    "getGas": "Obtenir du gaz",
    "hide": "Cacher",
    "learnMore": "Plus d'info",
    "lifiCheckout": "Paiement LI.FI",
    "lifiExchange": "Échange LI.FI",
    "light": "Clair",
    "max": "max",
    "ok": "Ok",
    "removeTransaction": "Supprimer la transaction",
    "reset": "Réinitialiser",
    "resetSettings": "Réinitialiser les paramètres",
    "reviewBridge": "Revoir le pont",
    "reviewPurchase": "Vérifiez votre achat",
    "reviewSwap": "Vérifier l'échange",
    "seeDetails": "Voir les détails",
    "showAll": "Afficher tout",
    "startBridging": "Commencer le pont",
    "startSwapping": "Commencer à échanger",
    "swap": "Échanger",
    "tryAgain": "Réessayer",
    "viewCoverage": "Voir la couverture",
    "viewOnExplorer": "Voir sur l'explorateur"
  },
  "header": {
    "activeTransactions": "Transactions actives",
    "bridge": "Bridge",
    "checkout": "Paiement",
    "exchange": "Échanger",
    "from": "Échanger de",
    "gas": "Gaz",
    "payWith": "Payer avec",
    "purchase": "Acheter",
    "purchaseDetails": "Détails de l'achat",
    "selectChain": "Sélectionner la chaîne",
    "selectWallet": "Sélectionnez votre portefeuille",
    "settings": "Paramètres",
    "swap": "Échanger",
    "to": "Échanger pour",
    "transactionDetails": "Détails de la transaction",
    "transactionHistory": "Historique de transaction",
    "walletConnected": "Portefeuille connecté",
    "youGet": "Vous obtenez"
  },
  "info": {
    "message": {
      "autoRefuel": "Vous avez peu de gaz sur {{chainName}}. En continuant, vous aurez assez de gaz pour compléter l'échange.",
      "emptyActiveTransactions": "Les transactions en cours apparaîtront ici. Une fois terminées, retrouvez-les dans l'historique des transactions.",
      "emptyTokenList": "Nous n'avons pas pu trouver de jetons sur la chaîne {{chainName}} ou vous n'en avez pas. Veuillez rechercher par adresse de contrat si votre jeton n'apparaît pas ou choisissez une autre chaîne.",
      "emptyTransactionHistory": "L'historique de transaction est uniquement stocké au niveau local et sera supprimé si vous effacez les données de votre navigateur.",
      "routeNotFound": "Raisons possibles : faible liquidité, le montant sélectionné est trop faible, les coûts de gaz sont trop élevés ou il n'y a pas de routes pour la combinaison sélectionnée."
    },
    "title": {
      "autoRefuel": "Obtenir du gaz",
      "emptyActiveTransactions": "Pas de transactions actives",
      "emptyTransactionHistory": "Pas de transactions récentes",
      "routeNotFound": "Aucun itinéraire disponible"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "Nous avons essayé de compléter la transaction, mais {{tool}} a manqué de liquidité pour le jeton {{tokenSymbol}}.",
      "exchangeSuccessful": "Il y a maintenant {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} dans le portefeuille {{walletAddress}} sur la chaîne {{chainName}}.",
      "purchaseSuccessful": "Vous possédez maintenant {{assetName}} dans le portefeuille {{walletAddress}} sur la chaîne {{chainName}}."
    },
    "title": {
      "bridgePartiallySuccessful": "Pont partiellement réussi",
      "bridgeSuccessful": "Pont réussi",
      "purchaseSuccessful": "Achat effectué",
      "refundIssued": "Remboursement émis",
      "swapPartiallySuccessful": "Échange partiellement réussi",
      "swapSuccessful": "Échange réussi"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "Les transactions actives ne sont stockées que localement et ne peuvent être récupérées si vous les supprimez.",
      "deleteTransactionHistory": "L'historique d transaction est uniquement stocké localement et ne peut être récupéré si vous le supprimez.",
      "highValueLoss": "La valeur des jetons reçus est nettement inférieure à celle des jetons échangés et au coût de la transaction.",
      "insufficientFunds": "Vous n'avez pas assez de fonds pour finaliser l'échange.",
      "insufficientGas": "Vous n'avez pas assez de gaz pour finaliser l'échange. Vous devez avoir au moins:",
      "rateChanged": "Le taux de change a changé. En continuant l'échange, vous devrez accepter le nouveau taux.",
      "resetSettings": "Cela réinitialisera la priorité de votre itinéraire, l'effet de glissement, le prix du gaz, les ponts et les plateformes d'échanges activés."
    },
    "title": {
      "deleteActiveTransactions": "Supprimer toutes les transactions actives ?",
      "deleteTransaction": "Supprimer cette transaction ?",
      "deleteTransactionHistory": "Supprimer l'historique de transaction ?",
      "highValueLoss": "Perte de valeur élevée",
      "insufficientGas": "Gaz insuffisant",
      "rateChanged": "Taux modifié",
      "resetSettings": "Réinitialiser les paramètres ?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "Le montant du transfert pour {{tokenSymbol}} dépasse votre allocation actuelle. Veuillez augmenter votre allocation et réessayer.",
      "insufficientFunds": "Vous n'avez pas assez de gaz pour couvrir le coût de la transaction.",
      "slippageThreshold": "L'effet de glissement est supérieur au seuil défini. Veuillez demander un nouvel itinéraire pour obtenir un nouveau devis.",
      "transactionFailed": "Veuillez consulter l'explorateur de blocs pour plus d'informations.",
      "transactionNotSent": "La transaction n'a pas été envoyée. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} sur {{chainName}} restent dans votre portefeuille.",
      "transactionRejected": "Votre signature est requise pour compléter la transaction. {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} sur {{chainName}} restent dans votre portefeuille.",
      "unknown": "Veuillez réessayer ou contacter le support."
    },
    "title": {
      "allowanceRequired": "Allocation insuffisante",
      "balanceIsTooLow": "Le solde est trop bas.",
      "chainSwitch": "Changement de chaîne nécessaire.",
      "gasLimitIsTooLow": "La limite de gaz est trop basse.",
      "insufficientFunds": "Fonds insuffisants",
      "slippageNotMet": "Les conditions de l'effet de glissement ne sont pas remplies.",
      "transactionCanceled": "Transaction annulée.",
      "transactionFailed": "La transaction a échoué.",
      "transactionRejected": "Signature requise.",
      "transactionUnderpriced": "La transaction est sous-évaluée.",
      "transactionUnprepared": "Impossible de préparer la transaction.",
      "unknown": "Il y a eu un problème.",
      "walletAddressInvalid": "L'adresse du portefeuille n'est pas valide.",
      "walletAddressRequired": "L'adresse du portefeuille est nécessaire.",
      "walletEnsAddressInvalid": "L'adresse du portefeuille n'est pas valide ou le réseau ne supporte pas l'ENS."
    }
  },
  "tooltip": {
    "additionalProviderFee": "Ponts additionnels, DEX et frais de service.",
    "estimatedNetworkFee": "Frais de réseau estimés.",
    "estimatedTime": "Durée d'exécution de l'échange estimé en minutes.",
    "notFound": {
      "text": "Nous n'avons pas trouvé cette page.",
      "title": "404"
    },
    "numberOfSteps": "Un certain nombre d'étapes d'échange. Chaque étape peut contenir 1 à 2 transactions nécessitant une signature.",
    "progressToNextUpdate": "Les données affichées seront automatiquement actualisées après {{value}} secondes. Cliquez ici pour les mettre à jour manuellement.",
    "recommended": "Une voie bon marché qui équilibre complexité et facilité d'utilisation.",
    "settingsModified": "Paramètres (modifiés)"
  },
  "main": {
    "crossStepDetails": "Passer de {{from}} à {{to}} via {{tool}}",
    "currentAmount": "Montant actuel",
    "estimatedTime": "{{value}}m",
    "featuredTokens": "Jetons en vedette",
    "from": "De",
    "fromAmount": "Vous payez",
    "gasCost": "Coût du gaz",
    "gasFeeEstimated": "frais de gaz estimés",
    "gasFeePaid": "frais de gaz payés",
    "inProgress": "en cours",
    "nftStepDetails": "Acheter un NFT via {{tool}}",
    "onChain": "sur {{chainName}}",
    "otherTokens": "Autres jetons",
    "ownedBy": "Propriétaire",
    "process": {
      "crossChain": {
        "actionRequired": "Veuillez signer la transaction.",
        "done": "Transaction Bridge confirmée",
        "pending": "En attente de la transaction bridge",
        "started": "Préparation de la transaction bridge"
      },
      "nft": {
        "done": "NFT acheté"
      },
      "receivingChain": {
        "done": "Bridge complété",
        "partial": "Bridge partiellement complété",
        "pending": "En attente de la chaîne de destination",
        "refunded": "Transaction bridge remboursée"
      },
      "swap": {
        "actionRequired": "Veuillez signer la transaction.",
        "done": "Échange terminé.",
        "pending": "En attente de la transaction d'échange",
        "started": "Préparation de la transaction d'échange"
      },
      "switchChain": {
        "actionRequired": "Changement de chaîne requis.",
        "done": "Chaîne changée avec succès."
      },
      "tokenAllowance": {
        "done": "Allocation de jetons approuvée.",
        "pending": "En attente de l'allocation de jetons",
        "started": "Fixation de l'allocation de jeton."
      }
    },
    "quotedAmount": "Montant indiqué",
    "rateChange": "Taux de change",
    "receiving": "En cours de réception",
    "refuelStepDetails": "Obtenir du gaz via {{tool}}",
    "selectChain": "Sélectionner la chaîne",
    "selectChainAndToken": "Sélectionnez la chaîne et le jeton",
    "selectToken": "Choisissez un jeton",
    "sendToAddress": "Envoyer à {{address}}",
    "sendToWallet": "Envoyer vers un autre portefeuille",
    "sending": "Envoi",
    "sentToAddress": "Envoyé à {{address}}",
    "stepBridge": "Bridge",
    "stepBridgeAndBuy": "Bridge et acheter",
    "stepDetails": "{{tool}} via LI.FI",
    "stepSwap": "Échanger",
    "stepSwapAndBridge": "Échange et Bridge",
    "stepSwapAndBuy": "Échanger et acheter",
    "supportId": "ID de support",
    "swapStepDetails": "Échanger sur {{chain}} via {{tool}}",
    "tags": {
      "cheapest": "Pas cher",
      "fastest": "Rapide",
      "insurable": "Assurable",
      "insurance": "Assurance",
      "insured": "Assuré",
      "recommended": "Recommandé",
      "safest": "Sûr"
    },
    "to": "À",
    "tokenOnChain": "{{tokenSymbol}} sur {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} sur {{chainName}}",
    "tokenSearch": "Recherche par nom de jeton ou adresse",
    "valueLoss": "Perte de valeur",
    "walletAddressOrEns": "Adresse du portefeuille ou nom ENS"
  },
  "insurance": {
    "bridgeExploits": "Des dysfonctionnements de pont, des hacks ou des exploits",
    "insure": "Assurer <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> en transit :",
    "insured": "Vous avez assuré <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> en transit :",
    "slippageError": "Erreur dans le slippage pour les jetons reçus"
  },
  "settings": {
    "enabledBridges": "Bridges activés",
    "enabledExchanges": "Échanges autorisés",
    "gasPrice": {
      "fast": "Rapide",
      "normal": "Normal",
      "slow": "Lent",
      "title": "Prix du gaz"
    },
    "routePriority": "Priorité de l'itinéraire",
    "showDestinationWallet": "Afficher le portefeuille de destination",
    "slippage": "Effet de glissement",
    "resetSettings": "Vous utilisez des paramètres personnalisés limitant le nombre de routes disponibles."
  },
  "wallet": {
    "extensionNotFound": "Veuillez vous assurer que seule l'extension de navigateur {{name}} est active avant de choisir ce portefeuille."
  }
}
